import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/** API は UTC の ISO 8601 を返す。表示は JST(docs/api-conventions.md 1)。 */
export function jst(iso: string | null | undefined): string {
  if (!iso) return "";
  return dayjs.utc(iso).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss");
}
